import React, { useEffect, useState } from "react";
import Select from "react-select";
import { getApi } from "../../../services/api/globalApi";

const { forwardRef, useRef, useImperativeHandle } = React;

const LearnCategoriesSelect = forwardRef(({ oldCategory, onChange, label }, ref) => {
  const [categoryData, setCategoryData] = useState([]);
  const [categoriesOption, setCategoriesOption] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  useImperativeHandle(ref, () => ({
    afterSubmit() {
      setSelectedCategories([]);
      getCategory();
    },
  }));


  console.log(oldCategory);

  const getCategory = async (params) => {
    const path = "admin/learnCategories/withoutPaginate";
    try {
      const response = await getApi({ path, params: { ...params } });
      setCategoryData(response?.data?.result);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCategory();
  }, []);

  useEffect(() => {
    console.log(categoryData);
    let newCategory = [];

    // categoriesOption.length <= 0 &&
    categoryData?.map((item) =>
      newCategory.push({
        value: item._id,
        label: item.name,
      })
    );
    setCategoriesOption(newCategory);
  }, [categoryData]);

  function handleCategory(data) {
    setSelectedCategories(data);
    const newData = data.map((item) => {
      return item.value;
    });
    onChange(newData || []);
  }

  useEffect(() => {
    console.log(oldCategory);
    if (oldCategory?.length > 0) {
      let selectedCategories = [];
      for (let i = 0; i < oldCategory?.length; i++) {
        let isExist = categoryData.filter((item) => {
          return item._id == oldCategory[i];
        });
        selectedCategories.push({
          label: isExist[0]?.name,
          value: isExist[0]?._id,
        });
        console.log(isExist);
      }
      console.log(selectedCategories);
      setSelectedCategories(selectedCategories);
    }
  }, [oldCategory, categoryData]);

  console.log(selectedCategories);

  return (
    <div>
      {label ? (
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {label}
        </label>
      ) : null}
      <Select
        classNamePrefix="admin-select"
        isRtl
        className=""
        options={categoriesOption}
        placeholder="انتخاب دسته بندی"
        value={selectedCategories}
        onChange={handleCategory}
        isSearchable={true}
        isMulti
      />
    </div>
  );
});

export default LearnCategoriesSelect;
